var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#D351FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6511 5.83203H19.332C19.9278 5.83203 20.4595 5.85039 20.9361 5.91456C23.4753 6.19872 24.1628 7.39037 24.1628 10.6537V16.447C24.1628 19.7104 23.4753 20.902 20.9361 21.1862C20.4595 21.2504 19.937 21.2687 19.332 21.2687H10.6511C10.0553 21.2687 9.52364 21.2504 9.04697 21.1862C6.5078 20.902 5.82031 19.7104 5.82031 16.447V10.6537C5.82031 7.39037 6.5078 6.19872 9.04697 5.91456C9.52364 5.85039 10.0553 5.83203 10.6511 5.83203Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4453 11.625H19.8186",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1758 16.9316H10.1941H19.8283",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.418 24.166H19.5846",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5939 11.6087H10.6022",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6213 11.6087H13.6295",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcPink);
export default __webpack_public_path__ + "static/media/pc-pink.a350d01edd843f8ad42f078ed3ecb6f9.svg";
export { ForwardRef as ReactComponent };